import { useRecentGames } from "@/app/(api)/api/listGames/useRecentGames.js";
import { GAME_ENTRY_CONTAINER, GAME_LIST, VIEW_MORE_ENTRY } from "@/components/account/game/GameEntries.js";
import Link from "next/link";
import { cn } from "@rosette/ts/src/util/cn.js";
import React from "react";
import { GameEntries } from "@/components/account/game/GameEntries.js";
import type { APIUser } from "@rosette/ts/src/business/api/api_schema.js";


interface RecentGamesProps {
    user: APIUser;
}


export function RecentGames({ user }: RecentGamesProps) {
    const { games, endOfGames, gamesLoading, gamesError } = useRecentGames(user);
    return (
        <div className={GAME_LIST}>
            <h2>
                Recent Games
            </h2>
            <GameEntries
                user={user}
                games={games}
                gamesLoading={gamesLoading}
                gamesError={gamesError} />

            {games && !endOfGames && (
                <p className={GAME_ENTRY_CONTAINER}>
                    <Link
                        className={cn(
                            VIEW_MORE_ENTRY,
                            "px-4 py-3 shadow-md",
                        )}
                        href={`/u/${user.username}/games`}>

                        View older games...
                    </Link>
                </p>
            )}
        </div>
    );
}
